import { render, staticRenderFns } from "./component-two.vue?vue&type=template&id=1187168f&scoped=true&"
import script from "./component-two.vue?vue&type=script&lang=js&"
export * from "./component-two.vue?vue&type=script&lang=js&"
import style0 from "./component-two.vue?vue&type=style&index=0&id=1187168f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187168f",
  null
  
)

export default component.exports